import translations from '../../components/location/ts/en';
import { registerLocale } from '../../components/location/localeStrings';

registerLocale('en', translations);
